export interface IconShape {
  t: 'path' | 'circle' | 'rect';
  d?: string;
  cx?: number;
  cy?: number;
  r?: number;
  x?: number;
  y?: number;
  w?: number;
  h?: number;
  rx?: number;
}

export type IconName =
  | 'home' | 'menu' | 'bell' | 'search' | 'filter' | 'plus' | 'help-circle'
  | 'chevron-left' | 'chevron-right' | 'chevron-down'
  | 'download' | 'upload' | 'copy' | 'link' | 'settings'
  | 'edit' | 'eye' | 'grid' | 'check' | 'user' | 'user-circle'
  | 'sales' | 'accounting' | 'shield' | 'users' | 'truck'
  | 'users-group' | 'circle-x' | 'file-text' | 'file-text-short'
  | 'check-square' | 'note-check' | 'send' | 'bar-up'
  | 'sliders'
  | 'message-warning' | 'file-check' | 'check-circle' | 'x-circle'
  | 'truck-front' | 'warning-triangle' | 'close' | 'log-out'
  | 'building' | 'box' | 'scale' | 'briefcase' | 'dollar'
  | 'camera' | 'camera-sm' | 'columns' | 'map-pin' | 'phone'
  | 'mail' | 'clipboard' | 'id-card' | 'notebook' | 'cube'
  | 'file-upload' | 'list-lines'
  | 'upload-cloud' | 'trash' | 'credit-card' | 'search-check' | 'umbrella'
  | 'globe' | 'office' | 'clock' | 'external' | 'calendar'
  | 'bolt';

export const ICON_REGISTRY: Record<IconName, IconShape[]> = {
  home: [{ t: 'path', d: 'M3 10.6 12 3l9 7.6M5 9.5V20h5v-6h4v6h5V9.5' }],
  menu: [{ t: 'path', d: 'M3 6h18M3 12h18M3 18h18' }],
  search: [{ t: 'circle', cx: 11, cy: 11, r: 7 }, { t: 'path', d: 'M21 21l-4-4' }],
  filter: [{ t: 'path', d: 'M3 5h18l-7 8v6l-4-2v-4z' }],
  plus: [{ t: 'path', d: 'M12 5v14M5 12h14' }],
  'help-circle': [
    { t: 'circle', cx: 12, cy: 12, r: 9 },
    { t: 'path', d: 'M9.5 9a2.6 2.6 0 014.8 1.4c0 1.8-2.3 2.1-2.3 3.6M12 17.5h.01' },
  ],
  'chevron-left': [{ t: 'path', d: 'M15 6l-6 6 6 6' }],
  'chevron-right': [{ t: 'path', d: 'M9 6l6 6-6 6' }],
  'chevron-down': [{ t: 'path', d: 'M6 9l6 6 6-6' }],
  download: [{ t: 'path', d: 'M12 3v12M7 11l5 4 5-4M5 21h14' }],
  upload: [{ t: 'path', d: 'M12 15V3M7 7l5-4 5 4M5 21h14' }],
  copy: [
    { t: 'rect', x: 9, y: 9, w: 11, h: 11, rx: 2 },
    { t: 'path', d: 'M5 15V5a2 2 0 012-2h10' },
  ],
  link: [{ t: 'path', d: 'M10 13a5 5 0 007 0l3-3a5 5 0 00-7-7l-1 1M14 11a5 5 0 00-7 0l-3 3a5 5 0 007 7l1-1' }],
  settings: [
    { t: 'circle', cx: 12, cy: 12, r: 3 },
    { t: 'path', d: 'M19.4 15a1.6 1.6 0 00.3 1.8l.1.1a2 2 0 11-2.8 2.8l-.1-.1a1.6 1.6 0 00-2.7 1.1V21a2 2 0 11-4 0v-.1A1.6 1.6 0 005 19.4l-.1.1a2 2 0 11-2.8-2.8l.1-.1A1.6 1.6 0 003.3 14H3a2 2 0 110-4h.1A1.6 1.6 0 004.6 5L4.5 5a2 2 0 112.8-2.8l.1.1A1.6 1.6 0 0010 3.3V3a2 2 0 114 0v.1a1.6 1.6 0 002.7 1.1l.1-.1a2 2 0 112.8 2.8l-.1.1a1.6 1.6 0 001.1 2.7H21a2 2 0 110 4h-.1a1.6 1.6 0 00-1.5 1z' },
  ],
  edit: [{ t: 'path', d: 'M12 20h9M16.5 3.5a2.1 2.1 0 013 3L7 19l-4 1 1-4z' }],
  eye: [
    { t: 'path', d: 'M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7-10-7-10-7z' },
    { t: 'circle', cx: 12, cy: 12, r: 2.6 },
  ],
  grid: [
    { t: 'rect', x: 3, y: 3, w: 7, h: 7, rx: 1.5 },
    { t: 'rect', x: 14, y: 3, w: 7, h: 7, rx: 1.5 },
    { t: 'rect', x: 3, y: 14, w: 7, h: 7, rx: 1.5 },
    { t: 'rect', x: 14, y: 14, w: 7, h: 7, rx: 1.5 },
  ],
  check: [{ t: 'path', d: 'M20 6L9 17l-5-5' }],
  user: [
    { t: 'circle', cx: 12, cy: 8, r: 3.4 },
    { t: 'path', d: 'M5 20c0-3.4 3-5.3 7-5.3s7 1.9 7 5.3' },
  ],
  'user-circle': [
    { t: 'path', d: 'M12 12.5a4 4 0 100-8 4 4 0 000 8zM4.5 20c0-3.6 3.4-5.5 7.5-5.5s7.5 1.9 7.5 5.5' },
  ],
  sales: [{ t: 'path', d: 'M4 20V11M10 20V5M16 20v-6M2 20h18' }],
  accounting: [{ t: 'path', d: 'M4 5h16v14H4zM4 9.5h16M9 14h2' }],
  shield: [{ t: 'path', d: 'M12 3 5 6v5c0 4.3 3 7.4 7 9 4-1.6 7-4.7 7-9V6z' }],
  users: [{ t: 'path', d: 'M9 11a3.2 3.2 0 100-6.4 3.2 3.2 0 000 6.4zM3 20c0-3.3 2.7-5 6-5s6 1.7 6 5M16 13.6c2.2.4 4 2.3 4 5' }],
  truck: [{ t: 'path', d: 'M3 7h10v8H3zM13 10h4l4 3.5V15h-8M7 18.4a1.6 1.6 0 100-3.2 1.6 1.6 0 000 3.2zM17 18.4a1.6 1.6 0 100-3.2 1.6 1.6 0 000 3.2z' }],
  'users-group': [{ t: 'path', d: 'M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2M9 11a4 4 0 100-8 4 4 0 000 8M23 21v-2a4 4 0 00-3-3.87M16 3.13a4 4 0 010 7.75' }],
  'circle-x': [{ t: 'path', d: 'M12 21a9 9 0 100-18 9 9 0 000 18zM9.2 9.2l5.6 5.6M14.8 9.2l-5.6 5.6' }],
  'file-text': [{ t: 'path', d: 'M14 3H7a2 2 0 00-2 2v14a2 2 0 002 2h10a2 2 0 002-2V8zM14 3v5h5M9 13h6M9 17h6' }],
  'file-text-short': [{ t: 'path', d: 'M14 3H7a2 2 0 00-2 2v14a2 2 0 002 2h10a2 2 0 002-2V8zM14 3v5h5M9 13h6M9 17h4' }],
  'check-square': [
    { t: 'rect', x: 4, y: 4, w: 16, h: 16, rx: 2.5 },
    { t: 'path', d: 'M8.5 12.2l2.3 2.3 4.9-5' },
  ],
  'note-check': [{ t: 'path', d: 'M9 11l3 3 8-8M21 12v7a2 2 0 01-2 2H5a2 2 0 01-2-2V5a2 2 0 012-2h11' }],
  send: [{ t: 'path', d: 'M22 2L11 13M22 2l-7 20-4-9-9-4z' }],
  'bar-up': [{ t: 'path', d: 'M4 20h16M7.5 16V10M12 16V6M16.5 16v-4' }],
  sliders: [{ t: 'path', d: 'M5 8h9M18 8h1M5 16h1M10 16h9M14 6v4M9 14v4' }],
  'message-warning': [
    { t: 'path', d: 'M21 15a2 2 0 01-2 2H8l-5 4V5a2 2 0 012-2h14a2 2 0 012 2z' },
    { t: 'path', d: 'M12 8v3M12 14h.01' },
  ],
  'file-check': [
    { t: 'path', d: 'M14 3H7a2 2 0 00-2 2v14a2 2 0 002 2h10a2 2 0 002-2V8z' },
    { t: 'path', d: 'M14 3v5h5M9 13l2 2 4-4' },
  ],
  'check-circle': [
    { t: 'circle', cx: 12, cy: 12, r: 9 },
    { t: 'path', d: 'M8.5 12l2.4 2.4L15.5 9.5' },
  ],
  'x-circle': [
    { t: 'circle', cx: 12, cy: 12, r: 9 },
    { t: 'path', d: 'M9 9l6 6M15 9l-6 6' },
  ],
  'truck-front': [{ t: 'path', d: 'M3 12h2l2-5h10l2 5h2M5 12v5h2M19 12v5h-2M7 17h10M7.5 14.4a.4.4 0 100-.8M16.5 14.4a.4.4 0 100-.8' }],
  'warning-triangle': [
    { t: 'path', d: 'M12 3l9 16H3z' },
    { t: 'path', d: 'M12 9v4M12 16.5h.01' },
  ],
  close: [{ t: 'path', d: 'M6 6l12 12M18 6L6 18' }],
  'log-out': [{ t: 'path', d: 'M16 17l5-5-5-5M21 12H9M12 21H5a2 2 0 01-2-2V5a2 2 0 012-2h7' }],
  building: [{ t: 'path', d: 'M3 21V8l9-5 9 5v13M3 21h18M9 21v-6h6v6' }],
  box: [{ t: 'path', d: 'M21 16V8l-9-5-9 5v8l9 5 9-5zM3 8l9 5 9-5' }],
  scale: [{ t: 'path', d: 'M10.3 4l-5 16M13.7 4l5 16M4 20h16M9 11h6' }],
  briefcase: [{ t: 'path', d: 'M3 8h18v12H3zM8 8V6a2 2 0 012-2h4a2 2 0 012 2v2' }],
  dollar: [{ t: 'path', d: 'M12 2v20M17 6.5a4 4 0 00-4-2.5h-2a3 3 0 000 6h2a3 3 0 010 6h-2a4 4 0 01-4-2.5' }],
  camera: [
    { t: 'rect', x: 3, y: 6, w: 18, h: 14, rx: 2 },
    { t: 'circle', cx: 12, cy: 13, r: 3.4 },
    { t: 'path', d: 'M8 6l1.5-2h5L16 6' },
  ],
  'camera-sm': [
    { t: 'rect', x: 3, y: 6, w: 18, h: 14, rx: 2 },
    { t: 'circle', cx: 12, cy: 13, r: 3 },
  ],
  columns: [{ t: 'path', d: 'M4 9h16M4 15h16M10 4L8 20M16 4l-2 16' }],
  'map-pin': [
    { t: 'path', d: 'M12 21s7-5.5 7-11a7 7 0 10-14 0c0 5.5 7 11 7 11z' },
    { t: 'circle', cx: 12, cy: 10, r: 2.6 },
  ],
  phone: [
    { t: 'rect', x: 6, y: 2, w: 12, h: 20, rx: 2.4 },
    { t: 'path', d: 'M11 18h2' },
  ],
  mail: [
    { t: 'rect', x: 3, y: 5, w: 18, h: 14, rx: 2 },
    { t: 'path', d: 'M3 7l9 6 9-6' },
  ],
  clipboard: [
    { t: 'rect', x: 3, y: 4, w: 18, h: 16, rx: 2 },
    { t: 'path', d: 'M8 4v16M11 9h6M11 13h6' },
  ],
  'id-card': [
    { t: 'rect', x: 3, y: 4, w: 18, h: 16, rx: 2 },
    { t: 'circle', cx: 9, cy: 10, r: 2 },
    { t: 'path', d: 'M5 17c0-2 2-3 4-3s4 1 4 3M15 9h4M15 13h4' },
  ],
  notebook: [
    { t: 'rect', x: 4, y: 3, w: 16, h: 18, rx: 2 },
    { t: 'path', d: 'M8 3v18M11 8h6M11 12h6' },
  ],
  cube: [{ t: 'path', d: 'M21 8l-9-5-9 5 9 5 9-5zM3 8v8l9 5 9-5V8M12 13v8' }],
  'file-upload': [{ t: 'path', d: 'M14 3H7a2 2 0 00-2 2v14a2 2 0 002 2h10a2 2 0 002-2V8zM14 3v5h5M12 18v-6M9 15l3-3 3 3' }],
  'list-lines': [{ t: 'path', d: 'M4 6h16M4 12h16M4 18h11' }],
  bell: [
    { t: 'path', d: 'M18 8a6 6 0 10-12 0c0 7-3 9-3 9h18s-3-2-3-9' },
    { t: 'path', d: 'M13.7 21a2 2 0 01-3.4 0' },
  ],
  'upload-cloud': [{ t: 'path', d: 'M12 16V4M7 9l5-5 5 5M4 16v3a1 1 0 001 1h14a1 1 0 001-1v-3' }],
  trash: [{ t: 'path', d: 'M4 7h16M9 7V5a1 1 0 011-1h4a1 1 0 011 1v2M6 7l1 13a1 1 0 001 1h8a1 1 0 001-1l1-13M10 11v6M14 11v6' }],
  'credit-card': [
    { t: 'rect', x: 2, y: 5, w: 20, h: 14, rx: 2 },
    { t: 'path', d: 'M2 10h20' },
  ],
  'search-check': [
    { t: 'circle', cx: 11, cy: 11, r: 7 },
    { t: 'path', d: 'M21 21l-4-4M9 11l1.5 1.5L14 9' },
  ],
  umbrella: [{ t: 'path', d: 'M12 3a9 7 0 00-9 7h18a9 7 0 00-9-7zM12 10v10M12 20a2 2 0 002-2' }],
  globe: [{ t: 'path', d: 'M12 21a9 9 0 100-18 9 9 0 000 18zM3 12h18M12 3c2.4 2.6 2.4 15.4 0 18M12 3c-2.4 2.6-2.4 15.4 0 18' }],
  office: [{ t: 'path', d: 'M5 21V5a2 2 0 012-2h7a2 2 0 012 2v16M5 21h14M9 7h2M9 11h2M9 15h2' }],
  clock: [{ t: 'circle', cx: 12, cy: 12, r: 9 }, { t: 'path', d: 'M12 7v5l3 3' }],
  external: [{ t: 'path', d: 'M18 13v6a2 2 0 01-2 2H5a2 2 0 01-2-2V8a2 2 0 012-2h6M15 3h6v6M10 14L21 3' }],
  calendar: [{ t: 'rect', x: 3, y: 4, w: 18, h: 18, rx: 2 }, { t: 'path', d: 'M16 2v4M8 2v4M3 10h18' }],
  bolt: [{ t: 'path', d: 'M13 2L3 14h7l-1 8 10-12h-7z' }],
};
